import type { SupStoredTxSettingsServices } from "@/types";
import useApi from "@/hooks/api/useApi";

export interface SupportedService {
  display_name: string;
  icon: string;
  logo?: string;
  deposit_disabled?: boolean;
  withdraw_disabled?: boolean;
  key: number;
}

type ResponseSupported = Record<SupStoredTxSettingsServices, SupportedService[]>;

/**
 * @package api:go
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/3472327-f5319162-5d84-4fd0-a01f-051f8f4df9df?ctx=documentation
 */
export default function useSupported(enabled: boolean = true) {
  const { data, isLoading, error, isError, mutate } = useApi<ResponseSupported, ResponseSupported>(
    {
      path: `/supported/`,
      api: "v2",
    },
    {
      enabled,
      strategy: "cached",
    }
  );

  return {
    data,
    error,
    isLoading,
    isError,
    mutate,
  };
}
